import combineReducers from 'redux/lib/combineReducers';

import employee from './employee';

export default combineReducers({
  employee,
});
